// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"98d02ccb","453":"216f4969"}[chunkId] + ".chunk.js";
};